export default __webpack_public_path__ + "static/media/process.9eccb153.svg";